module.exports = __webpack_public_path__ + "img/6.df904c16.png";